(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-header-source"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('#siteHeader announcement-carousel').forEach((carousel)=>{const items=[...carousel.querySelectorAll('[data-announcement-item]')];if(!items.length)return;let index=0;const show=()=>{items.forEach((item,i)=>{item.classList.toggle('opacity-0',i!==index);item.classList.toggle('pointer-events-none',i!==index);item.classList.toggle('opacity-100',i===index);item.classList.toggle('pointer-events-auto',i===index);item.setAttribute('aria-hidden',String(i!==index));});};carousel.querySelector('[data-announcement-prev]')?.addEventListener('click',()=>{index=(index+items.length-1)%items.length;show();});carousel.querySelector('[data-announcement-next]')?.addEventListener('click',()=>{index=(index+1)%items.length;show();});show();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-market-header"]) return;
  try {
    
  (() => {
    const prepareEnquiry = () => {
      const copy = document.querySelector('[data-mm-enquiry-copy]');
      if (!copy) return;
      const params = new URLSearchParams(window.location.search);
      const enquiry = params.get('enquiry');
      if (enquiry !== 'wholesale' && enquiry !== 'seller') return;
      if (params.has('contact_posted')) return;
      const body = document.getElementById('ContactForm-body');
      const form = body?.closest('form');
      if (!body || !form || body.value.trim()) return;
      if (form.querySelector('[aria-invalid="true"], [role="alert"], .errors, .form-status, .form__message, .contact-form__message')) return;
      const navigation = performance.getEntriesByType('navigation')[0];
      if (navigation?.type === 'back_forward') return;
      const title = copy.dataset[enquiry + 'Title'];
      const message = copy.dataset[enquiry + 'Body'];
      if (!title || !message) return;
      body.value = message;
      const heading = document.querySelector('#MainContent h1');
      if (heading) heading.textContent = title;
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', prepareEnquiry, { once: true });
    } else {
      prepareEnquiry();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
